<template>
 <div class="appointmentcontainer pb100">
   <banner/>
  <crumbs/>
  <div class="container">
   <type-screen modelType="culturedistribution"
      :menu-id="this.$route.query.columnId"
      @typeObj="selectType"/>
    <ul class="ul-model1 clearfix">
      <li @click.stop="detaillink(item.menuId, item.id)" v-for="(item, index) in List" :key="index">
        <a>
<!--          <span class="collect"></span>-->
<!--          <collect collect-style="iconcollect3"-->
<!--                   :is-select="item.persionalCommon.isCollect"-->
<!--                   :count="item.persionalCommon.collectCount"-->
<!--                   @changecount="changeCollect"-->
<!--                   :menu-id="item.menuId"-->
<!--                   :business-id="item.id" />-->
          <div class="imgbox">
            <img class="imgtop" :src="getImage(item.imageUrl)" alt="">
          </div>
          <div class="txtbox">
            <h2 class="textover">{{ item.name }}</h2>
            <div class="descbox height48">
              <p class="textover">日期：<span>{{ getTime(item.startTime) }}</span></p>
              <p class="textover" v-if="item.sponsor !== undefined && item.sponsor !== ''">单位：<span>{{ item.sponsor }}</span></p>
              <p class="textover" v-if="item.organizer !== undefined && item.organizer !== ''">主办：<span>{{ item.organizer }}</span></p>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <nodata v-show="nodataflag"/>
    <el-pagination
      @current-change="handleCurrentChange"
      :page-size="Param.limit"
      :pager-count="5"
      :current-page.sync="currentPage"
      layout="prev, pager, next"
      :total="listTotal"
      class="pagemodel1">
    </el-pagination>
  </div>
 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import { scrollAnimation } from '@/utils/index'
import { getCultureDistributionList } from '@/api/culturedistribution/index'
import { timeFormat } from '@/utils/validate'
import Collect from '@/components/amount/collect'
export default {
  name: 'culturedistribution',
  meta: {
    showHeader: true
  },
  components: {
    Collect,
    typeScreen,
    crumbs,
    banner,
    nodata
  },
  data () {
    return {
      Param: {
        page: 1,
        limit: 12,
        menuId: this.$route.query.columnId,
        types: '',
        distributionType: '',
        venueType: '',
        areaType: ''
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    changeCollect (val) {
      this.List.forEach((item) => {
        if (item.id === val.id) {
          item.persionalCommon.collectCount = val.count
          item.persionalCommon.isCollect = val.isSelect
        }
      })
    },
    getTime (val) {
      let hhmm = timeFormat(val, 'yymmddhhmm').split(' ')[1]
      if (hhmm === '00:00') {
        return timeFormat(val, 'yymmdd')
      } else {
        return timeFormat(val, 'yymmddhhmm')
      }
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 获取列表 */
    getList () {
      getCultureDistributionList(this.Param).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      console.log(obj)
      this.Param.distributionType = obj.distributionType
      this.Param.venueType = obj.venueType
      this.Param.areaType = obj.areaType
      this.Param.types = obj.customTypeId
      this.Param.page = 1
      this.currentPage = 1
      this.getList()
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    detaillink (columnId, id) {
      this.$router.push({path: '/culturedistributiondetail', query: {columnId: columnId, id: id}})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/culturedistribution/list.vue